import {
  Message
} from 'element-ui';
import moment from "moment"

export function getToday() {
  let date = (new Date()).getTime()
  return moment(date).format("YYYY-MM-DD")
}

/*json对象转为tree带编码*/
export function Json2TreeCode(data, id = "0") {
  let parentData = _.filter(data, {
    parentId: id
  });
  if (parentData.length) {
    _.map(parentData, item => {
      if (item.crewSize) {
        item['label'] = item.departName + "（编制 " + item.crewSize + "）"
      } else {
        item['label'] = item.departName
      }
      let tree = Json2TreeCode(data, item.id)
      if (tree.length) {
        item['children'] = tree
      }
    })
  }
  return parentData
}

/*json对象转为tree*/
export function Json2Tree(data, id = "0") {
  let parentData = _.filter(data, {
    parentId: id
  });
  if (parentData.length) {
    _.map(parentData, item => {
      let tree = Json2Tree(data, item.id)
      if (tree.length) {
        item['children'] = tree
      }
    })
  }
  return parentData
}

/*url参数转为json*/
export function urlParams2Json(url) {
  let hash;
  let myJson = {};
  let hashes = url.slice(url.indexOf('?') + 1).split('&');
  for (let i = 0; i < hashes.length; i++) {
    hash = hashes[i].split('=');
    myJson[hash[0]] = hash[1];
  }
  return myJson;
}

/*获取当前页url的参数(json格式)*/
export function getUrlQuery() {
  let url = decodeURI(location.href)
  let hash;
  let myJson = {};
  let hashes = url.slice(url.indexOf('?') + 1).split('&');
  for (let i = 0; i < hashes.length; i++) {
    hash = hashes[i].split('=');
    myJson[hash[0]] = hash[1];
  }
  return myJson;
}

/*json对象转url参数*/
export function Json2UrlQuery(json = {}) {
  let param = ''
  param = Object.keys(json).map(function (key) {
    // body...
    return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
  }).join("&")
  return param
}

export function urlReplace(url, PathParam) {
  let newUrl = url;
  let urls = url.match(/\{[^\}]+\}/g)
  if (PathParam) {
    for (var i in PathParam) {
      for (var j = 0; j < urls.length; j++) {
        if ((urls[j].slice(1, -1)) === i) {
          newUrl = url.split(urls[j])[0] + PathParam[i] + url.split(urls[j])[1]
        }
      }
    }
  }
  return newUrl;
}

export function getValue(data) {
  let result = {};
  _.mapKeys(data, (value, key) => {
    result[key] = value.value;
  });
  return result;
}

export function setValue(obj, from) {
  _.mapKeys(from, (item, key) => {
    item.value = obj[key] == -1 ? "" : obj[key];
  });
  return from;
}

export function clearValue(from) {
  _.mapKeys(from, item => {
    item.value = undefined;
  });
  return from;
}

export function resFilter(res, cb) {
  if (res.status == 200) {
    Message.success(res.data.data);
    cb && cb.then();
  }
}

export function getTenYears() {
  let date = new Date;
  let startYear = date.getFullYear();
  let arr = Array(10)
  let yearList = _.map(arr, (item, i) => {
    return {
      code: startYear + i,
      name: startYear + i + "年"
    }
  })
  return yearList
}

export function recursionRouter(userRouter = [], allRouter = []) {
  var realRoutes = []
  allRouter.forEach((v, i) => {
    userRouter.forEach((item, index) => {
      if (item.englishName === v.name) {
        v.meta.title = item.name;
        realRoutes.push(v)
      }
    })
  })
  return realRoutes
}

export function title(titleText) {
  window.document.title = `OA ${titleText ? ` | ${titleText}` : ''}`
}

export function download({
  url,
  fileName
}) {
  fetch(url).then(res => res.blob().then(blob => {
    var a = document.createElement('a');
    var url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }))
};



// WEBPACK FOOTER //
// ./src/common/util.js